import { useStore } from 'vuex';

/**
 * Get env props
 *
 * @returns {EnvProps}
 */
export function useEnvProps() {
  const store = useStore();
  return store.state.envProps;
}

export default {
  useEnvProps,
};
